/** Textes alternatifs des photographies, fidèles au contenu réel de chaque image. */
const FR = [
  "Table dressée et lustre en rondins dans la pièce à vivre du Chalet",
  "Grande table en bois et cuisine noire du Chalet",
  "Séjour avec canapé, table basse en bois et peau posée sur le parquet",
  "Coin salon sous rampant avec télévision et table basse en bois",
  "Cuisine noire équipée et table dressée pour six personnes",
  "Table en bois et bancs dressés devant la cuisine",
  "Chambre mansardée avec lit double et lampe de chevet",
  "Chambre sous rampant avec lit double et fenêtre de toit",
  "Chambre avec volets intérieurs en bois et chaise comtoise",
  "Chambre mansardée avec lit double éclairée par une fenêtre de toit",
  "Chambre avec deux lits doubles côte à côte sous la fenêtre de toit",
  "Chambre mansardée avec lit double et lampes de chevet",
  "Chambre sous les combles avec lit double et radiateur",
  "Chambre avec lit double, commode en bois et fenêtre de toit",
  "Skis anciens accrochés au mur en bois près d'une porte",
  "Salle de bain avec vasque en pierre, grand miroir et meuble noir",
  "WC séparés habillés de bois et de noir",
  "Couloir en bois avec un tableau représentant un cerf",
  "Couloir menant à la pièce à vivre, tableau de cerf au mur",
  "Coin salon avec télévision, fauteuil et peau posée au sol",
  "Couloir d'entrée aux portes sombres",
  "Raquettes à neige anciennes accrochées dans le couloir",
  "Couloir aux portes noires sous rampant",
  "Couloir avec skis anciens éclairés et trophée mural",
  "Chambre avec luge ancienne, chaise comtoise et volets en bois",
  "Fenêtre à volets de bois, luge ancienne et chaise comtoise",
  "Trois patères en forme de tête de cerf sur le mur en bois",
  "Skis et bâtons anciens éclairés contre le mur en bois",
  "Paire de raquettes à neige anciennes en décoration",
  "Canapé d'angle et table basse en bois dans le séjour",
  "Chambre sous les combles avec deux couchages au sol et armoire ancienne",
  "Lit préparé avec coussins et table de chevet en bois",
  "Patère en bois sculptée en forme de sapin",
  "Lampe de chevet posée sur un rondin de bois près du lit",
  "Façade en pierre du gîte et places de parking",
  "Façade de La Ferme Comtoise éclairée à la tombée du jour",
];

const EN = [
  "Table laid for a meal under the log chandelier in the Chalet living room",
  "Large wooden table and black kitchen in the Chalet",
  "Living room with sofa, wooden coffee table and hide on the wooden floor",
  "Sitting area under the sloping ceiling with television and wooden coffee table",
  "Fitted black kitchen and table laid for six",
  "Wooden table and benches laid in front of the kitchen",
  "Attic bedroom with double bed and bedside lamp",
  "Bedroom under the sloping ceiling with double bed and roof window",
  "Bedroom with wooden interior shutters and a traditional Comtois chair",
  "Attic bedroom with double bed lit by a roof window",
  "Bedroom with two double beds side by side under the roof window",
  "Attic bedroom with double bed and bedside lamps",
  "Bedroom under the eaves with double bed and radiator",
  "Bedroom with double bed, wooden chest of drawers and roof window",
  "Vintage skis hung on the wooden wall beside a door",
  "Bathroom with stone washbasin, large mirror and black unit",
  "Separate toilet finished in wood and black",
  "Wooden corridor with a painting of a stag",
  "Corridor leading to the living room, stag painting on the wall",
  "Sitting area with television, armchair and hide on the floor",
  "Entrance corridor with dark doors",
  "Vintage snowshoes hung in the corridor",
  "Corridor with black doors under the sloping ceiling",
  "Corridor with lit vintage skis and a wall trophy",
  "Bedroom with vintage sledge, Comtois chair and wooden shutters",
  "Wooden shuttered window, vintage sledge and traditional Comtois chair",
  "Three stag-head hooks on the wooden wall",
  "Vintage skis and poles lit against the wooden wall",
  "Pair of vintage snowshoes used as decoration",
  "Corner sofa and wooden coffee table in the living room",
  "Room under the eaves with two beds on the floor and an antique wardrobe",
  "Bed made up with cushions and a wooden bedside table",
  "Wooden coat hook carved in the shape of a fir tree",
  "Bedside lamp on a wooden log next to the bed",
  "Stone façade of the lodging and parking spaces",
  "Façade of La Ferme Comtoise lit at dusk",
];

const DE = [
  "Gedeckter Tisch unter dem Holzleuchter im Wohnraum des Chalets",
  "Großer Holztisch und schwarze Küche im Chalet",
  "Wohnraum mit Sofa, Couchtisch aus Holz und Fell auf dem Holzboden",
  "Sitzecke unter der Dachschräge mit Fernseher und Couchtisch aus Holz",
  "Eingerichtete schwarze Küche und für sechs Personen gedeckter Tisch",
  "Holztisch mit Bänken, gedeckt vor der Küche",
  "Dachzimmer mit Doppelbett und Nachttischlampe",
  "Zimmer unter der Dachschräge mit Doppelbett und Dachfenster",
  "Zimmer mit hölzernen Innenfensterläden und traditionellem Stuhl",
  "Dachzimmer mit Doppelbett, beleuchtet durch ein Dachfenster",
  "Zimmer mit zwei Doppelbetten nebeneinander unter dem Dachfenster",
  "Dachzimmer mit Doppelbett und Nachttischlampen",
  "Zimmer unter dem Dach mit Doppelbett und Heizkörper",
  "Zimmer mit Doppelbett, Holzkommode und Dachfenster",
  "Alte Ski an der Holzwand neben einer Tür",
  "Badezimmer mit Steinwaschbecken, großem Spiegel und schwarzem Möbel",
  "Separates WC in Holz und Schwarz gehalten",
  "Holzvertäfelter Flur mit einem Hirschbild",
  "Flur zum Wohnraum, Hirschbild an der Wand",
  "Sitzecke mit Fernseher, Sessel und Fell auf dem Boden",
  "Eingangsflur mit dunklen Türen",
  "Alte Schneeschuhe im Flur aufgehängt",
  "Flur mit schwarzen Türen unter der Dachschräge",
  "Flur mit beleuchteten alten Ski und Wandtrophäe",
  "Zimmer mit altem Schlitten, traditionellem Stuhl und Holzläden",
  "Fenster mit Holzläden, alter Schlitten und traditioneller Stuhl",
  "Drei Haken in Form von Hirschköpfen an der Holzwand",
  "Alte Ski und Stöcke beleuchtet an der Holzwand",
  "Paar alte Schneeschuhe als Dekoration",
  "Ecksofa und Couchtisch aus Holz im Wohnraum",
  "Raum unter dem Dach mit zwei Betten am Boden und altem Schrank",
  "Bezogenes Bett mit Kissen und hölzernem Nachttisch",
  "Holzhaken in Form einer Tanne geschnitzt",
  "Nachttischlampe auf einem Holzstamm neben dem Bett",
  "Steinfassade der Unterkunft und Parkplätze",
  "Fassade von La Ferme Comtoise in der Abenddämmerung beleuchtet",
];

const ES = [
  "Mesa puesta bajo la lámpara de troncos en la sala del Chalet",
  "Gran mesa de madera y cocina negra del Chalet",
  "Salón con sofá, mesa baja de madera y piel sobre el suelo de madera",
  "Rincón de salón bajo el techo inclinado con televisión y mesa baja de madera",
  "Cocina negra equipada y mesa puesta para seis personas",
  "Mesa de madera con bancos puesta frente a la cocina",
  "Dormitorio abuhardillado con cama doble y lámpara de noche",
  "Dormitorio bajo el techo inclinado con cama doble y ventana de tejado",
  "Dormitorio con contraventanas interiores de madera y silla tradicional",
  "Dormitorio abuhardillado con cama doble iluminado por una ventana de tejado",
  "Dormitorio con dos camas dobles contiguas bajo la ventana de tejado",
  "Dormitorio abuhardillado con cama doble y lámparas de noche",
  "Dormitorio bajo el tejado con cama doble y radiador",
  "Dormitorio con cama doble, cómoda de madera y ventana de tejado",
  "Esquís antiguos colgados en la pared de madera junto a una puerta",
  "Baño con lavabo de piedra, gran espejo y mueble negro",
  "Aseo independiente revestido de madera y negro",
  "Pasillo de madera con un cuadro de un ciervo",
  "Pasillo hacia la sala, cuadro de ciervo en la pared",
  "Rincón de salón con televisión, sillón y piel en el suelo",
  "Pasillo de entrada con puertas oscuras",
  "Raquetas de nieve antiguas colgadas en el pasillo",
  "Pasillo con puertas negras bajo el techo inclinado",
  "Pasillo con esquís antiguos iluminados y trofeo de pared",
  "Dormitorio con trineo antiguo, silla tradicional y contraventanas de madera",
  "Ventana con contraventanas de madera, trineo antiguo y silla tradicional",
  "Tres percheros con forma de cabeza de ciervo en la pared de madera",
  "Esquís y bastones antiguos iluminados contra la pared de madera",
  "Par de raquetas de nieve antiguas como decoración",
  "Sofá rinconero y mesa baja de madera en el salón",
  "Habitación bajo el tejado con dos camas en el suelo y armario antiguo",
  "Cama preparada con cojines y mesilla de noche de madera",
  "Percha de madera tallada con forma de abeto",
  "Lámpara de noche sobre un tronco de madera junto a la cama",
  "Fachada de piedra del alojamiento y plazas de aparcamiento",
  "Fachada de La Ferme Comtoise iluminada al anochecer",
];

const IT = [
  "Tavola apparecchiata sotto il lampadario in tronchi nella zona giorno dello Chalet",
  "Grande tavolo in legno e cucina nera dello Chalet",
  "Soggiorno con divano, tavolino in legno e pelle sul pavimento in legno",
  "Angolo salotto sotto il tetto spiovente con televisione e tavolino in legno",
  "Cucina nera attrezzata e tavola apparecchiata per sei persone",
  "Tavolo in legno con panche apparecchiato davanti alla cucina",
  "Camera mansardata con letto matrimoniale e lampada da comodino",
  "Camera sotto il tetto spiovente con letto matrimoniale e finestra sul tetto",
  "Camera con scuri interni in legno e sedia tradizionale",
  "Camera mansardata con letto matrimoniale illuminata da una finestra sul tetto",
  "Camera con due letti matrimoniali affiancati sotto la finestra sul tetto",
  "Camera mansardata con letto matrimoniale e lampade da comodino",
  "Camera sottotetto con letto matrimoniale e radiatore",
  "Camera con letto matrimoniale, cassettiera in legno e finestra sul tetto",
  "Sci d'epoca appesi alla parete in legno accanto a una porta",
  "Bagno con lavabo in pietra, grande specchio e mobile nero",
  "WC separato rivestito in legno e nero",
  "Corridoio in legno con un quadro raffigurante un cervo",
  "Corridoio che porta alla zona giorno, quadro con cervo alla parete",
  "Angolo salotto con televisione, poltrona e pelle sul pavimento",
  "Corridoio d'ingresso con porte scure",
  "Racchette da neve d'epoca appese nel corridoio",
  "Corridoio con porte nere sotto il tetto spiovente",
  "Corridoio con sci d'epoca illuminati e trofeo a parete",
  "Camera con slitta d'epoca, sedia tradizionale e scuri in legno",
  "Finestra con scuri in legno, slitta d'epoca e sedia tradizionale",
  "Tre appendiabiti a forma di testa di cervo sulla parete in legno",
  "Sci e bastoncini d'epoca illuminati contro la parete in legno",
  "Paio di racchette da neve d'epoca come decorazione",
  "Divano angolare e tavolino in legno nel soggiorno",
  "Stanza sottotetto con due letti a terra e armadio antico",
  "Letto rifatto con cuscini e comodino in legno",
  "Appendiabiti in legno intagliato a forma di abete",
  "Lampada da comodino su un ceppo di legno accanto al letto",
  "Facciata in pietra dell'alloggio e posti auto",
  "Facciata di La Ferme Comtoise illuminata all'imbrunire",
];

const GALLERY = { fr: FR, en: EN, de: DE, es: ES, it: IT };

/** Illustration au trait servant de visuel d'attente (aucun lieu réel représenté). */
const PLACEHOLDER = {
  fr: "Illustration au trait d'une ferme comtoise",
  en: "Line illustration of a traditional Comtois farmhouse",
  de: "Strichzeichnung eines typischen Comtois-Bauernhauses",
  es: "Ilustración a línea de una granja comtesa tradicional",
  it: "Illustrazione al tratto di una cascina tradizionale comtoise",
};

const COVER = {
  fr: "Façade en bois et pierre de La Ferme Comtoise éclairée à la tombée du jour",
  en: "Wood and stone façade of La Ferme Comtoise lit at dusk",
  de: "Holz- und Steinfassade von La Ferme Comtoise in der Abenddämmerung beleuchtet",
  es: "Fachada de madera y piedra de La Ferme Comtoise iluminada al anochecer",
  it: "Facciata in legno e pietra di La Ferme Comtoise illuminata all'imbrunire",
};

/** ALT d'une photo de la galerie du Chalet ; repli neutre si la photo est inconnue. */
export function photoAlt(lang, url, index) {
  const list = GALLERY[lang] || FR;
  if (url && url.includes("77EBAEA4")) return PLACEHOLDER[lang] || PLACEHOLDER.fr;
  if (url && url.includes("IMG_8267")) return COVER[lang] || COVER.fr;
  return list[index] || list[0];
}

export function coverAlt(lang) {
  return COVER[lang] || COVER.fr;
}
